import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CheckOut } from './check-in-kiosk-feature-check-out.actions';
import { getCheckOutState } from './check-in-kiosk-feature-check-out.selectors';

@Component({
  selector: 'frontend-check-out-routed',
  templateUrl: './check-in-kiosk-feature-check-out-routed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CheckOutRoutedComponent {
  state$: any;

  constructor(private store: Store<any>) {
    this.state$ = this.store.pipe(select(getCheckOutState));
  }

  onSave(data) {
    this.store.dispatch(new CheckOut(data));
  }
}
